module.exports = __webpack_public_path__ + "media/aerial-farm-hd01.e605d690.mp4";